const dict = {
  en: {
    "null invocation failed due to configuration.": "Incorrect username or password",
    "User does not exist": "Incorrect username or password",
    "Enter your username": "Phone number or email address",
    "Enter your password": "Password",
    Username: "Username (phone number or email address)",
    Password: "Password: "
  },
  tr: {
    "Sign In": "GİRİŞ YAP",
    "Sign Up": "Kaydol",
    "Sign Out": "Çıkış Yap",
    "Sign in to your account": "Giriş yapın",
    Username: "Kullanıcı adı: (Telefon numarası ya da mail adresi)",
    Password: "Parola: ",
    "Enter your username": "Telefon numarası ya da mail adresi",
    "Enter your password": "Parola",
    "No account? ": "Hesabınız yok mu? ",
    "Forgot your password? ": "Parolanızı mı unuttunuz? ",
    "Reset password": "Parola sıfırlama",
    "User already exists": "Böyle bir kullanıcı zaten mevcut",
    "Incorrect username or password": "Yanlış kullanıcı adı veya parola",
    "Invalid password format": "Parola, formata uygun değil",
    "Create account": "Hesap oluştur",
    "Old Password": "Eski Parola",
    "Confirm Password": "Yeni Parola Onayı",
    "Forgot Password": "Parolamı Unuttum",
    "Change Password": "Parola Değiştir",
    Change: "Değiştir",
    Cancel: "Vazgeç",
    "New Password": "Yeni Parola",
    Email: "Email",
    "Phone Number": "Telefon Numarası",
    "Confirm a Code": "Kodu Onayla",
    "Confirm Sign In": "Girişi onayla",
    "Confirm Sign Up": "Kaydı onayla",
    "Back to Sign In": "Giriş ekranına geri dön",
    "Send Code": "Kodu gönder",
    Confirm: "Onayla",
    "Resend Code": "Kodu tekrar gönder",
    Submit: "Gönder",
    Skip: "Atla",
    Verify: "Onayla",
    "Verify Contact": "İletişim bilgilerini onayla",
    Code: "Kod",
    "Confirmation Code": "Onay Kodu",
    "Lost your code? ": "Kodunuzu mu kaybettiniz? ",
    "Account recovery requires verified contact information":
      "Hesabı kurtarabilmeniz için aşağıdaki iletişim bilgilerinden birinin onaylanmış olması gerekiyor",
    "Invalid phone number format": `Telefon numarası formatı şu şekilde olmalı: +12345678900`,
    "Create Account": "Hesap oluştur",
    "Have an account? ": "Hesabınız mı var? ",
    "Sign in": "Giriş yap",
    "Create a new account": "Yeni hesap oluştur",
    "Reset your password": "Parolanı sıfırla",
    "An account with the given email already exists.": "Verilen e-posta adına bir hesap zaten mevcut.",
    "Username cannot be empty": "Kullanıcı adı boş bırakılamaz",
    "Password attempts exceeded": "Parola deneme limiti aşıldı",
    "Unauthorized user": "Yetkisiz kullanıcı",
    "null invocation failed due to configuration.": "Yanlış kullanıcı adı veya şifre",
    "User does not exist": "Yanlış kullanıcı adı veya şifre"
  },
  ar: {
    "null invocation failed due to configuration.": "اسم المستخدم أو كلمة المرور غير صحيحة",
    "User does not exist": "اسم المستخدم أو كلمة المرور غير صحيحة",
    "Enter your username": "رقم الهاتف أو عنوان البريد الإلكتروني",
    "Enter your password": "كلمة المرور",
    Username: "اسم المستخدم (رقم الهاتف أو عنوان البريد الإلكتروني)",
    Password: "اسم المستخدم:"
  }
};

export default dict;
